import React, { useState } from "react";
import { useAnalyticsApi } from "react-use-analytics-api";

import { Box } from "@mui/material/";

import {
  AnalyticsDashboard,
  SessionsByDeviceCategoryChart,
} from "react-analytics-charts";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";

const SessionsByDevice = ({ dashboard }) => {
  const [period, setPeriod] = useState(30);
  const { t, i18n } = useTranslation();

  const { ready, gapi, authorized, error } = useAnalyticsApi();
  let clientId =
    "568824200639-58enea0l8cr2arus6f1hech205ibqvci.apps.googleusercontent.com";
  let viewId = "261404142";

  return (
    <Box>
      {!dashboard && (
        <>
          <Box sx={{ pt: 3, pb: 1, fontSize: "22px" }}>
            <span style={{ fontWeight: "bold", fontSize: "16px" }}>
              {t("Device Category Chart")}{" "}
            </span>

            <span className="pink_link">
              {/* <a
                target="_blank"
                rel="noreferrer"
                href="https://blog.hubspot.com/marketing/organic-search-definition-100-words"
                style={{ fontSize: "15px" }}
              >
                Doc
              </a> */}
            </span>
          </Box>
          <Box sx={{ pb: 1, color: "gray" }}>{t("device")}</Box>
        </>
      )}

      <FormControl sx={{ mt: 2, width: 300 }}>
        <InputLabel id="demo-simple-select-label">{t("Set Period")}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={period}
          label="Period"
          onChange={(e) => setPeriod(e.target.value)}
          sx={{ width: 300 }}
        >
          <MenuItem value={10}>10 {t("Days")}</MenuItem>
          <MenuItem value={30}>1 {t("Month")}</MenuItem>
          <MenuItem value={60}>3 {t("Month")}</MenuItem>
          <MenuItem value={180}>6 {t("Month")}</MenuItem>
          <MenuItem value={270}>9 {t("Month")}</MenuItem>
          <MenuItem value={365}>1 {t("Year")}</MenuItem>
        </Select>
      </FormControl>
      <AnalyticsDashboard
        authOptions={{ clientId }}
        renderCharts={(gapi, viewId) => {
          return (
            <SessionsByDeviceCategoryChart
              gapi={gapi}
              viewId={viewId}
              days={28}
            />
          );
        }}
      />
    </Box>
  );
};

export default SessionsByDevice;
